import React, { useEffect, useState } from 'react';
import '../../App.css';
import calenderApi from '../../api/calenderApi';
import { useAvailabilityComments } from '../../hooks/apiHook/operationDetails';
import { getAdjustedDate } from '../../utils/dateUtils';
import useBgColorStore from '../../store/bgColor';

interface NotesSectionProps {
  ownerId: number;
}

interface AvailabilityComment {
  comment: string;
}

const NotesSection: React.FC<NotesSectionProps> = ({ ownerId }) => {
  const { bgColor } = useBgColorStore();
  const [availabilityComment, setAvailabilityComment] =
    useState<AvailabilityComment | null>(null);

  const {
    data: availabilityData,
    isLoading,
    isError,
    refetch,
  } = useAvailabilityComments(getAdjustedDate(), ownerId, 7);
  //TODO: now I have pass 7 as a day - show comment - I will add this in constant file

  useEffect(() => {
    if (availabilityData) {
      setAvailabilityComment(availabilityData);
    }
  }, [availabilityData]);

  const commentsArray =
    availabilityComment?.comment
      ? availabilityComment?.comment?.split(',').map((c) => c.trim()) || []
      : [];

  return (
    <div>
      {commentsArray && commentsArray?.length > 0 ? (
        <div className={`marquee-container  shadow-md rounded-sm ${bgColor}`}>
          <div className="marquee-content">
            {commentsArray.map((note, index) => (
              <span key={index} className="text-xs text-text-black mt-2">
                <span className="text-xs text-text-primary mr-1">●</span> {note}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default NotesSection;
